import { css } from '@emotion/react'
import { CornerRadius, cssVar, Spacing, ThemedColors } from '@opallabs/gem'

export const container = css({
  alignItems: 'center',
  blockSize: Spacing.M,
  borderRadius: CornerRadius.Small,
  display: 'inline-flex',
  marginInline: Spacing.XS,
})

export const acceptButton = css({
  blockSize: 'inherit',
  borderColor: cssVar(ThemedColors.GemPrimary3),
  borderInlineEnd: 0,
  borderStartEndRadius: 0,
  borderEndEndRadius: 0,
})

export const rejectButton = css({
  blockSize: 'inherit',
  borderColor: cssVar(ThemedColors.GemPrimary3),
  borderInlineStart: 0,
  borderStartStartRadius: 0,
  borderEndStartRadius: 0,
})
